import { render, staticRenderFns } from "./CandidateSkillsRating.vue?vue&type=template&id=5e8e6bfb&"
import script from "./CandidateSkillsRating.vue?vue&type=script&lang=js&"
export * from "./CandidateSkillsRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports